module.exports = __webpack_public_path__ + "media/rot3.848d3a21.mp4";